if (!customElements.get('full-width-banner')) {
  class FullWidthBanner extends HTMLElement {
    constructor() {
      super();

      this.height = this.checkWindowWidth();

      window.addEventListener('resize', () => {
        this.height = this.checkWindowWidth();

        this.checkWindowWidth.bind(this);
      });

      window.addEventListener('scroll', () => this.initParallax(this.height));
    }

    checkWindowWidth() {
      let height = this.getBoundingClientRect().height;

      if (window.innerWidth <= 475) {
        height = (window.innerWidth / 100 * 197.95).toFixed(2);
      } else if (window.innerWidth <= 768 && window.innerWidth > 475) {
        height = (window.innerWidth * 1.3).toFixed(2);
      } else {
        height = (window.innerWidth / 100 * 55.49).toFixed(2);
      }

      return height;
    }

    initParallax (sectionHeight) {
      const wrapper = this.querySelector('.full-width-banner__wrapper-inner');
      const rect = this.getBoundingClientRect();
      const scrolledHeight = window.innerHeight - rect.top;
      let scrolledPercentage;

      if (scrolledHeight <= 0) {
        scrolledPercentage = 0;
      } else if (scrolledHeight >= sectionHeight) {
        scrolledPercentage = 100;
      } else {
        scrolledPercentage = (scrolledHeight / sectionHeight) * 100;
      }

      if (scrolledPercentage >= 50 && scrolledPercentage <= 100) {
        const translateY = -((scrolledPercentage - 50) / 50) * (sectionHeight * 0.5);
        const minHeight = sectionHeight * 0.5;
        const currentHeight = sectionHeight - ((scrolledPercentage - 50) / 50) * (sectionHeight - minHeight);

        this.style.height = `${currentHeight}px`;
        wrapper.style.transform = `translateY(${translateY}px)`;
      } else {
        wrapper.style.transform = `translateY(0)`;
        this.style.height = `${sectionHeight}px`;
      }
    }
  }

  customElements.define('full-width-banner', FullWidthBanner);
}
